import React, { useMemo } from 'react';
import styled from 'styled-components';
import { mq, Title, Link, Accordion } from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import { FaqQuestionNewRecord } from '~/config/generated/graphql';
import Well from '~/App/views/ObjectPage/components/Well';
import { translateRoute } from '../../localization';
import { Path } from '@kvdbil/components/types/components/Link';
import StructuredText from '~/App/components/DatoCMS/StructuredText';
import { isEmptyDocument } from 'datocms-structured-text-utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;

  ${mq('tablet')} {
    flex-direction: row;
    column-gap: 1rem;
  }
`;

const Wrapper = styled.div`
  width: 100%;
`;

const Heading = styled(Title)`
  margin-bottom: 1.5rem;
`;

const LinkWrapper = styled.div`
  margin-top: 1rem;
`;

interface Props {
  questions: FaqQuestionNewRecord[] | undefined;
}

const MiniFAQ = ({ questions }: Props) => {
  const { t } = useTranslation();

  const items = useMemo(
    () =>
      questions
        ?.filter(q => q?.question && !isEmptyDocument(q?.answer))
        .map(q => ({
          title: q.question ?? '',
          text: <StructuredText data={q?.answer} />
        })),
    [questions]
  );

  return (
    <Container>
      <Well variant="stretchHeight" boxShadow={false}>
        <Wrapper>
          <Heading as="h2">{t('Do you have questions?')}</Heading>
          {items && <Accordion items={items} />}
          <LinkWrapper>
            <Link
              path={translateRoute(t, '/ROUTES.HELP') as Path}
              text={t('Do you have more questions')}
              typographyType="BodyLink"
              withUnderline
            />
          </LinkWrapper>
        </Wrapper>
      </Well>
    </Container>
  );
};

export default MiniFAQ;
